import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GlobalWarningComponent } from '../global-warning/global-warning.component';

@Component({
    selector: 'app-basic-layout',
    templateUrl: './basic-layout.component.html',
    styleUrls: ['./basic-layout.component.scss'],
    imports: [RouterModule, GlobalWarningComponent, CommonModule],
})
export class BasicLayoutComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
